let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qxgD")).then(() => parcelRequire('7h3zr'));